import { Lang } from "../i18n/translations";
import Navbar from "./Navbar";
import Footer from "./Footer";

interface Props {
  lang: Lang;
  onToggleLang: () => void;
  children: React.ReactNode;
  variant?: "home" | "support";
}

export default function Layout({ lang, onToggleLang, children, variant = "home" }: Props) {
  return (
    <div className="app">
      <Navbar lang={lang} onToggleLang={onToggleLang} variant={variant} />
      {children}
      <Footer lang={lang} />
    </div>
  );
}
